import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/store/index.js";
import "./registerServiceWorker";
import Buefy from "buefy";
import VeeValidate from "vee-validate";
import firebase from "firebase";
import VueStripeCheckout from "vue-stripe-checkout";
import VModal from "vue-js-modal";
import VueTypedJs from "vue-typed-js";
import Carousel3d from "vue-carousel-3d";

var config = {
  apiKey: "AIzaSyDbxED_D1L3GvsdnqJZ25k47Fc2lrTd0lA",
  authDomain: "stronghireinc.firebaseapp.com",
  databaseURL: "https://stronghireinc.firebaseio.com",
  projectId: "stronghireinc",
  storageBucket: "stronghireinc.appspot.com",
  messagingSenderId: "272234882644"
};

firebase.initializeApp(config);

Vue.config.productionTip = false;

Vue.use(Carousel3d);

Vue.use(VueTypedJs);
Vue.use(Buefy);
Vue.use(VeeValidate, {
  aria: true
});

Vue.use(VueStripeCheckout, "pk_test_PvkMhcTmBJCboAgveVn7N5Sd00g17GChJe");
Vue.use(VModal);

let app = "";

firebase.auth().onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      store,
      beforeCreate() {
        if (user) {
          console.log(user);
          console.log(store.state);
          store.commit("setUser", user);
          console.log(store.state);
        }
      },
      router,
      render: h => h(App)
    }).$mount("#app");
  } else {
    if (user) {
      // dispatch sign in
      console.log("dispatch sign in");
    } else {
      router.push("/login");
    }
  }
});
